import { SEARCH_RESULT_DISPLAY_NUMBER } from '../EventActivitySearchResults/EventActivitySearchResults';

export const loaderData = Array.from({ length: SEARCH_RESULT_DISPLAY_NUMBER }, (_, i) => ({
  id: i.toString(),
  index: i,
  name: '',
  description: '',
  event: null,
  icon: null,
}));
